import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
const Discipline = () => {
  useEffect(() => {
    document.title = 'Discipline -  Sacred Heart School, Ballia - U.P.';  
}, []); 
   return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>Discipline </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>Admission</li>
                            <li>|</li>
                            <li> Discipline </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                      <div className="col-lg-12">
                          <p>We, at Sacred Heart School, believe that there is a need and importance of discipline in our society and in our life. In our home, in schools, in the playground and everywhere in this world discipline brings order. Discipline is one of the basic requirements of a civilized life. Every society has to set certain norms for people to follow. Everything in this world is governed by a definite set of laws. It is very essential to live with co-operation, and brotherhood amongst each-other. Absence of discipline may lead to failure and backwardness of nation. But one can overcome these problems if everyone follows a personal code of conduct and maintains self-discipline for prosperity of the nation. Keeping this in mind the School takes following measures in order to maintain discipline.</p>      
                      </div>
                </div>
                <h1 className="head1">Corrective Disciplinary Action</h1>
                <div className='row'> 
                   <div className="col-lg-6">
                     <ul className="list schoolfee">
                       <li>Admonition and counselling </li>
                       <li>Parent/pupil conference </li>
                       <li> Modification of student classroom assignment or schedule </li>
                       <li> Student behaviour contract </li>
                       <li> Suspension of student for a specified period</li>
                    </ul>
                   </div>
                   <div className="col-lg-6">
                     <ul className="list schoolfee">
                       <li> Removal from class </li>
                       <li> Short-term suspension </li>
                       <li> Long-term suspension </li>
                       <li> Recommendation for expulsion</li>
                    </ul>
                   </div>
               </div> 
                <h1 className="head1"> Removal, Suspension and Expulsion of Pupils</h1>
                 <div className='row'> 
                   <div className="col-lg-12">
                     <ul className="list schoolfee">  
                           <li>A student found guilty of a serious breach of discipline can be summarily expelled from the School without any liability on the part of the institution and the dues paid will not be refundable.</li>
                           <li>If during the academic session, the School authorities are complicated in any litigation either by the student or by his/her Parent/Guardian, the School authorities reserve the right to cancel the admission of the concerned student without any prior notice, in order to maintain discipline and to safeguard the healthy atmosphere of the School from being vitiated.</li>
                       </ul>
                   </div>
               </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default Discipline